import type { RangePickerProps } from 'antd/es/date-picker';
import moment from 'moment';

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return current && current < moment().endOf('day');
};
